import { MatInputModule } from "@angular/material/input";
import { TranslateModule } from "@ngx-translate/core";
import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";

import { ButtonComponent } from "../button/button.component";
import { CheckboxComponent } from "../checkbox/checkbox.component";
import { IsEnglishDirective } from "../../directives";

import { PaymentMethod } from "src/app/core/enums/payment-method";

@Component({
  selector: "app-payment-methods",
  imports: [TranslateModule, MatDialogModule, ReactiveFormsModule, MatInputModule, IsEnglishDirective, ButtonComponent, CheckboxComponent],
  templateUrl: "./payment-methods.component.html",
  styleUrl: "./payment-methods.component.scss",
})
export class PaymentMethodsComponent {
  readonly #fb = inject(FormBuilder);
  readonly matDialogRef = inject(MatDialogRef);
  readonly #matDialogData = inject(MAT_DIALOG_DATA);

  isEnglish = true;
  PaymentMethod = PaymentMethod;

  allPaymentMethods = [PaymentMethod.Cash, PaymentMethod.SwapMachine, PaymentMethod.Online];

  showCardNumberForm = false;
  cardNumberForm = this.#fb.group({
    withBankMuscat: [false],
    prefix: ["", [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
    postFix: ["", [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
  });

  get withBankMuscat() {
    return this.cardNumberForm.get("withBankMuscat")?.value;
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    if (typeof this.#matDialogData === "object" && "availablePaymentMethods" in this.#matDialogData) {
      if (Array.isArray(this.#matDialogData.availablePaymentMethods)) {
        if (
          this.#matDialogData.availablePaymentMethods.length === 1 &&
          this.#matDialogData.availablePaymentMethods.includes(PaymentMethod.Online)
        ) {
          this.showCardNumberForm = true;
          return;
        }

        this.allPaymentMethods = this.#matDialogData.availablePaymentMethods;
      }
    }
  }

  onSubmit() {
    if (this.cardNumberForm.valid || !this.withBankMuscat) {
      this.matDialogRef.close({
        paymentMethod: PaymentMethod.Online,
        cardNumber: this.cardNumberForm.value,
      });
    }
  }
}
